import { MessageData } from '../components/MessageForm'
import $api from '../http'
import { AxiosResponse } from 'axios'

export default class MessageService {
  static async sendMessage(
    userId: string,
    data: MessageData,
  ): Promise<AxiosResponse<any>> {
    return $api.post<AxiosResponse>('/api/send-message', { userId, ...data })
  }
}
